import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LineItemComponent } from '@app/components/line-items/line-item';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  standalone: true,
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.css'],
  imports: [CommonModule, TranslateModule, LineItemComponent],
})
export class DropdownComponent {
  @Input() options: Array<string>;
  @Output() handleSelection: EventEmitter<string> = new EventEmitter<string>();
  @Input() testId!: string;

  onSelectOption(option: string) {
    this.handleSelection.emit(option);
  }
}
